module.exports = __webpack_public_path__ + "img/img_brand30.db67b2f4.jpg";